export default "__VITE_ASSET__hmkP0MR$__"